module.exports = __webpack_public_path__ + "static/media/arrow-button.d6f62bed.svg";